import { Check } from 'lucide-react';
import ScrollReveal from '@/components/ScrollReveal';

const jurisdictions = [
  {
    flag: '\u{1F1E6}\u{1F1EA}',
    name: 'Dubai International Financial Centre',
    badge: 'DFSA Authorized',
    description: "Operating under the oversight of the Dubai Financial Services Authority, ALC Bond leverages DIFC's English common law framework, independent courts, and world-class financial infrastructure for efficient bond structuring and SPV establishment.",
    features: [
      'English common law legal framework',
      'Independent DIFC Courts for dispute resolution',
      'Zero corporate and income tax',
      'Prescribed company SPV framework',
      'Global double taxation treaty network',
    ],
  },
  {
    flag: '\u{1F1E6}\u{1F1EA}',
    name: 'Abu Dhabi Global Market',
    badge: 'FSRA Regulated',
    description: "Regulated by the Financial Services Regulatory Authority, our ADGM presence enables access to Abu Dhabi's growing capital markets ecosystem, innovative aviation finance framework, and streamlined Islamic finance structures.",
    features: [
      'FSMR framework modeled on UK FSMA',
      'Aviation finance SPV specialization',
      'Islamic finance regulatory leadership',
      'ADGM Courts & arbitration center',
      'Progressive fintech regulatory sandbox',
    ],
  },
];

export default function Jurisdictions() {
  return (
    <section id="jurisdictions" className="bg-white py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <ScrollReveal>
          <p className="text-sm font-inter font-semibold uppercase tracking-wider mb-3" style={{ color: '#c9a84c' }}>
            Jurisdictions
          </p>
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl mb-4" style={{ color: '#0a1628' }}>
            Dual-Licensed. Dual-Jurisdictional.
          </h2>
          <p className="font-playfair font-bold text-3xl sm:text-4xl mb-14" style={{ color: '#0a1628' }}>
            One Standard of Excellence.
          </p>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-6">
          {jurisdictions.map((j, i) => (
            <ScrollReveal key={j.name} delay={i * 150}>
              <div
                className="rounded-xl p-6 sm:p-8 h-full"
                style={{
                  border: '1px solid #e5e7eb',
                  borderRadius: '12px',
                  transition: 'border-color 300ms ease, box-shadow 300ms ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#c9a84c';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(201,168,76,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                data-testid={`jurisdiction-card-${i}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-2xl">{j.flag}</span>
                  <h3 className="font-playfair font-semibold text-lg" style={{ color: '#0a1628' }}>
                    {j.name}
                  </h3>
                </div>

                <span
                  className="inline-block text-xs font-inter font-semibold px-3 py-1 rounded-full mb-5"
                  style={{ backgroundColor: 'rgba(201,168,76,0.1)', color: '#c9a84c' }}
                >
                  {j.badge}
                </span>

                <p className="font-inter text-sm leading-relaxed mb-6" style={{ color: '#6b7280' }}>
                  {j.description}
                </p>

                <ul className="space-y-3">
                  {j.features.map((feat) => (
                    <li key={feat} className="flex items-start gap-2">
                      <Check className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: '#2d8a56' }} strokeWidth={2} />
                      <span className="font-inter text-sm" style={{ color: '#374151' }}>{feat}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
